<header>
  <div class="icon">
    <mat-icon class="icon__content">lock</mat-icon>
  </div>

  <h1 class="heading">2-Factor Verification</h1>
</header>

<section>
  <p *ngIf="descriptionRef">
    <ng-container *ngTemplateOutlet="descriptionRef"></ng-container>
  </p>
  <div *ngIf="actionLabel">
    <button mat-flat-button
            color="primary"
            (click)="onClickAction()">{{actionLabel}}</button>
  </div>
</section>
